import { IDocumentProps, IFileProps } from '../../../props/general';
import Request from './../../request';

const CompanyDocumentService = {
  retrieve: async (companyId: string): Promise<IDocumentProps[]> => {
    try {
      const results = await Request.get(`/api/companies/${companyId}/documents`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (companyId: string, data: FormData): Promise<IDocumentProps> => {
    try {
      const result = await Request.post(`/api/companies/${companyId}/documents`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  delete: async (companyId: string, ids: string[]): Promise<void> => {
    try {
      const fd = new FormData();
      ids.forEach((id) => fd.append('ids[]', id));

      await Request.post(`/api/companies/${companyId}/documents/delete`, fd, 'multipart/form-data');
      return;
    } catch (e) {
      throw e;
    }
  },
};

export default CompanyDocumentService;